<template>
  <div class="subnavigation">
    <nav>
      <ul>
        <li  v-for="(subnav,i) in subNavs.subs[0]" :key="i">
            <span class="subnav_item" @click="updateActiveMenu(subnav.name)" :class="{ 'active': activeSubMenu(subnav.name) }">
                {{subnav.title}}
            </span>
        </li>
        <template v-for="(subnav,index) in subNavs.subs" :key="index">
            <li v-if="index>0">
                <span class="subnav_item" @click="updateActiveMenu(subnav.name,1)" :class="{ 'active': activeSubMenu(subnav.name) }">
                    {{subnav.title}}
                </span>
            </li>
        </template>
      </ul>
    </nav>
  </div>
</template>
<script>
import { updateMenu } from '@/utils/menu.js'
export default {
  data(){
    return{
      activeNav:'',
      subNavs:{},
    }
  },
  computed:{
    activeMenu:function() {
      return this.$store.state.menu.activeMenu;
    },
  },
  watch:{
    activeMenu:function(curValue, oldValue) {
      if (curValue && curValue !== oldValue) {
        this.updateNav()
      }
    }
    // $route:function(current){
    //   //console.log('현재 라우트 이름',current.name)
    //   if( this.activeNav != this.$store.state.menu.activeMenu)
    //   {
    //     this.activeNav = current.name
    //     this.updateNav()
    //   }
    // },
    // $route (to, from){
    //     console.log('to',to)
    //     console.log('from',from)
    // }
  },
    created(){
        this.activeNav = this.$store.state.menu.activeMenu
        this.updateNav()
    },
    methods:{
      activeSubMenu(input){
         return input === this.$store.state.menu.activeSubMenu;
        },
      updateNav(){
        //console.log('메뉴목록',this.$store.getters['menu/getMenu'])
        this.subNavs = this.$store.getters['menu/getMenu'].find((menu) => menu.name === this.activeMenu)
      },
      updateActiveMenu(document,otherlink) {
        let currentMenu =  this.$store.state.menu.activeMenu

        updateMenu(currentMenu, document, this.$store);
        if(otherlink ===1)
        {
             this.$router.push({
                path: "/main/community/"+ document
                });
        }else{
             this.$router.push({
            path: "/main/community/" + currentMenu +"/"+ document
            });
        }

        //this.$store.commit('menu/setActiveDocument', 'free');
      },
  }

}

</script>
<style lang="scss">
.subnavigation {
  width: 100%;
  height: 3.5rem;
  background-color: #157cf1;
  display: flex;
  justify-content: center;
  align-items: center;
  .subnav_item {
    text-decoration: none;
    color: #91dcf3;
    display: inline-block;
    padding: 0.75rem 1rem;
    border: 1px solid transparent;
    cursor:pointer;
  }

  .subnav_item:active,
  .subnav_item:hover,
  .subnav_item.active {
    border: 1px solid #91dcf3;
  }

  h1 {
    margin: 0;
  }

  h1 a {
    color: white;
    margin: 0;
  }

  h1 a:hover,
  h1 a:active,
  h1 a.router-link-active {
    border-color: transparent;
  }

  nav {
    width: 70%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  li {
    margin: 0 0.5rem;
  }
}


</style>
